module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/394.8270facf.png";